import React from 'react'
import { getInsightContentTypeDisplayText } from 'components/insightContent/utils/utils'
import { Theme } from 'features/ui/types'
import { useDisplayTheme } from 'hooks/useUiState'
// @ts-ignore
import { Dialog } from '@netbasequid/core'
import AccordionSectionType from 'components/insightContent/enum/AccordionSectionType'
import { InsightData } from 'schemas/action/InsightDataSchema'
import { CountTypeStrings } from 'enums/CountType'
import Sentiment, { SentimentStrings } from 'enums/Sentiment'
import { InsightContentSettingType } from 'components/insightContent/types'
import AccordionGroup from 'components/insightContent/visualization/AccordionGroup'
import InsightContentType from 'components/insightContent/enum/InsightContentType'
import { MetricTimeUnitStrings } from 'enums/MetricTimeUnit'
import GoToAnalysisButton from 'components/insightContent/visualization/GoToAnalysisButton'
import { sendTypedMessage } from 'utils/iframeUtil'
import { toExternal } from 'vo/util'
import {
  TopInfoBox,
  TopInfoRight,
  StyledTermContainer,
  StyledTermContent
} from 'components/insightContent/visualization/InfoBox/index.css'
import messageUtil from 'utils/messageUtil'
import InsightDialog from 'components/insightContent/visualization/InsightDialog'

const DIALOG_CONTENT_HEIGHT = '460px'

interface InsightModalProps {
  open: boolean
  onClose: () => void
  title?: string
  countType?: CountTypeStrings
  selectedInsights?: InsightData[]
  detailSetting?: InsightContentSettingType
  timeUnits?: MetricTimeUnitStrings[]
  forceNotScale?: boolean
  widgetSettingWithSelection?: any
}

const isNeutralSentiment = (sentiment?: SentimentStrings) =>
  sentiment && sentiment === Sentiment.NEUTRAL

const InsightModal = ({
  open,
  title,
  countType,
  selectedInsights,
  onClose,
  detailSetting,
  timeUnits,
  forceNotScale,
  widgetSettingWithSelection
}: InsightModalProps) => {
  const theme = useDisplayTheme() as Theme

  function goToAnalysis() {
    sendTypedMessage('goToAnalysis', toExternal(widgetSettingWithSelection))
  }

  return (
    <InsightDialog open={open} onClose={onClose}>
      <Dialog.DialogTitle>{title}</Dialog.DialogTitle>
      <TopInfoBox mode={theme}>
        {selectedInsights?.map((item: InsightData) => (
          <StyledTermContainer key={item.name}>
            <StyledTermContent mode={theme}>{messageUtil.sentiments(item.name!)}</StyledTermContent>
          </StyledTermContainer>
        ))}

        <TopInfoRight>
          <GoToAnalysisButton onClick={() => goToAnalysis()} />
        </TopInfoRight>
      </TopInfoBox>
      <Dialog.DialogContent height={DIALOG_CONTENT_HEIGHT}>
        <AccordionGroup
          timeUnits={timeUnits}
          forceNotScale={forceNotScale}
          countType={countType}
          insightContentsConfig={[
            {
              accordionTitle: getInsightContentTypeDisplayText(AccordionSectionType.SUMMARY),
              accordionContents: [
                {
                  insightContentType: InsightContentType.TOTAL_MEASURE,
                  detailSetting
                },
                {
                  insightContentType: InsightContentType.MEASURE_WITH_SENTIMENT,
                  detailSetting
                },
                {
                  insightContentType: InsightContentType.NET_SENTIMENT,
                  detailSetting
                },
                {
                  insightContentType: isNeutralSentiment(
                    detailSetting?.selectionFilter?.additionalSentiments?.[0]?.[0]
                  )
                    ? InsightContentType.NAME_MEASURE
                    : InsightContentType.NAME_MEASURE_WITH_SHARE_OF_SENTIMENT,
                  detailSetting
                }
              ]
            },
            {
              accordionTitle: getInsightContentTypeDisplayText(AccordionSectionType.SOUND_BITE),
              accordionContents: [
                {
                  insightContentType: InsightContentType.SOUND_BITE,
                  detailSetting
                }
              ]
            }
          ]}
        />
      </Dialog.DialogContent>
      <Dialog.DialogActions />
    </InsightDialog>
  )
}

export default InsightModal
